import ActualNumberOfSkips from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ActualNumberOfSkips";
import ATCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATCField";
import ATSField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATSField";
import Attachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/Attachment";
import ETCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ETCField";
import ExternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ExternalNotesAndAttachments";
import ImagesAttachments from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ImagesAttachments";
import InternalNotesAndAttachmentsComponent from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/InternalNotesAndAttachments";
import MarpolAnnexGrid from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/MarpolAnnexGrid";
import NotesField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/NotesField";
import RejectionReasonAndAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/RejectionReasonAndAttachment";
import ServiceReportAttachment from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ServiceReportAttachment";
import SpecialInstructionsField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/SpecialInstructionsField";
import type { ChangeStatusDrawerInfo } from "@features/vessel-call/vessel-call-status/PortServices/hoc/withDrawers";

interface ExtraFieldProps {
  serviceDetails: ChangeStatusDrawerInfo;
}

const MARPOL_OPTIONS_HSE_SLUDGE = [
  { value: "Oily residues (sludges)", label: "Oily residues (sludges)" },
  { value: "Scale and sludge from tank cleaning", label: "Scale and sludge from tank cleaning" },
  { value: "Other (Specify)", label: "Other (Specify)" },
];

const extraFieldsMap = {
  internalNotes: () => <InternalNotesAndAttachmentsComponent />,
  externalNotes: () => <ExternalNotesAndAttachmentsComponent />,
  rejectionReason: () => <RejectionReasonAndAttachment />,
  specialInstructions: () => <SpecialInstructionsField />,
  ats: (props: ExtraFieldProps) => <ATSField {...props} />,
  etc: (props: ExtraFieldProps) => <ETCField {...props} />,
  atc: (props: ExtraFieldProps) => <ATCField {...props} />,
  notes: () => <NotesField />,
  images: () => <ImagesAttachments />,
  attachment: () => <Attachment isPdfonly={true} />,
  serviceReportAttachment: () => <ServiceReportAttachment />,
  wasteResiduesForDischargeFacility: (props: ExtraFieldProps) => (
    <MarpolAnnexGrid {...props} marpolOptions={MARPOL_OPTIONS_HSE_SLUDGE} />
  ),
  actualNumberOfSkips: (props: ExtraFieldProps) => <ActualNumberOfSkips {...props} />,
};

type SludgeExtraFieldsProps = {
  currentFlowStep: any;
  selectedStatus: string;
} & ExtraFieldProps;

const SludgeExtraFields = ({
  currentFlowStep,
  selectedStatus,
  ...restProps
}: SludgeExtraFieldsProps) => {
  return (
    <div className="flex flex-col gap-2">
      {currentFlowStep?.statusesList?.[selectedStatus]?.extraFields?.length
        ? currentFlowStep.statusesList[selectedStatus].extraFields.map(
            (field: keyof typeof extraFieldsMap) => {
              const FieldComponent = extraFieldsMap[field];

              if (!FieldComponent) return null;

              return (
                <div className="mt-4" key={field}>
                  <FieldComponent {...restProps} />
                </div>
              );
            },
          )
        : null}
    </div>
  );
};

export default SludgeExtraFields;
